/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable consistent-return */
/* eslint-disable react/destructuring-assignment */
import React from 'react';

export default class Component extends React.Component {
  // 必要なprops

  closeModal = () => {
    const dialog = document.querySelector('.dialog.active');
    dialog.classList.remove('fadein');
    dialog.classList.add('fadeout');
    setTimeout(() => {
      var data = this.props.closeModal !== undefined ? this.props.closeModal() : '';
    }, 1000);
  };

  componentDidMount = () => {
    const dialogBack = document.querySelector('.dialog');
    const close = e => {
      const dialog = document.querySelector('.dialog-container');
      if (e && dialog.contains(e.target)) {
        return;
      }
      this.closeModal();
    };
    dialogBack.addEventListener('click', close);
  };

  render = () => {
    let okBtn;
    if (this.props.okClickHandler === null) {
      okBtn = null;
    } else {
      okBtn = (
        <span
          className={this.props.okBtnClass || 'btn btn-danger btn-block'}
          onClick={this.props.okClickHandler}
        >
          {this.props.okText || 'OK'}
        </span>
      );
    }
    const className = this.props.className
      ? this.props.className + (this.props.isOpen ? 'active fadein' : '')
      : `dialog ${this.props.isOpen ? 'active fadein' : ''}`;
    return (
      <div className={className}>
        <div className="dialog-wrapper task-created-modal">
          <div className="dialog-container">
            <div className="dialog-header">{this.props.headerTitle || '確認'}</div>
            <div className="dialog-body">
              {this.props.children}
              {(() => {
                if (okBtn) {
                  return <div className="text-center mt-4 ">{okBtn}</div>;
                }
              })()}
            </div>
          </div>
        </div>
      </div>
    );
  };
}
